import { Easing, FadeInUp, Keyframe } from 'react-native-reanimated';
import { SpringConfig } from 'react-native-reanimated/lib/typescript/animation/springUtils';

export const WHATS_NEW_CARD_HEIGHT = 408;
export const TRANSLATE_X_THRESHOLD = 200;
export const SWIPE_VELOCITY_THRESHOLD = 800;
export const TRANSLATE_X_THRESHOLD_RATIO = 0.35; // 35% of width
export const CARDS_LEFT_TEXT_ANIMATION_CONFIG = FadeInUp.duration(500).easing(Easing.inOut(Easing.ease));
export const SNAP_BACK_ANIMATION_CONFIG: SpringConfig = { damping: 25, stiffness: 500 };
export const MIDDLE_CARD_SCALE_FACTOR = 0.9;
export const BACK_CARD_SCALE_FACTOR = 0.8;
export const CARD_OFFSET = 12;
export const MIDDLE_CARD_OFFSET =
    (WHATS_NEW_CARD_HEIGHT - WHATS_NEW_CARD_HEIGHT * MIDDLE_CARD_SCALE_FACTOR) / 2 + CARD_OFFSET;
export const BACK_CARD_OFFSET =
    (WHATS_NEW_CARD_HEIGHT - WHATS_NEW_CARD_HEIGHT * BACK_CARD_SCALE_FACTOR) / 2 + CARD_OFFSET * 2;
export const WHATS_NEW_CARD_HORIZONTAL_MARGIN = 48;

// keyframe for mimicking the slack 'catch up' entering animation
export const whatsNewEnteringKeyframe = new Keyframe({
    0: {
        transform: [{ scale: 0.4 }],
        opacity: 0,
    },
    80: {
        transform: [{ scale: 1.005 }],
        opacity: 1,
        easing: Easing.out(Easing.cubic),
    },
    100: {
        transform: [{ scale: 1 }],
        opacity: 1,
        easing: Easing.inOut(Easing.ease),
    },
}).duration(500);
